var _path, _path2, _rect, _path3, _circle, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0318 41.3244C50.0142 37.9847 52.7073 35.2631 56.047 35.2455L96.5622 35.0323C99.9018 35.0147 102.623 37.7078 102.641 41.0475L102.826 76.1203L50.2164 76.3972L50.0318 41.3244Z",
    fill: "#C19B73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2168 76.3965L102.826 76.1196L103.011 111.192C103.028 114.532 100.335 117.254 96.9954 117.271L56.4802 117.484C53.1406 117.502 50.419 114.809 50.4014 111.469L50.2168 76.3965Z",
    fill: "#C19B73"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.4746,
    y: 41.2949,
    width: 41.1204,
    height: 28.4215,
    transform: "rotate(-0.301531 55.4746 41.2949)",
    fill: "#AF957B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4728 58.458C64.3819 56.3078 58.2991 61.0364 55.8941 63.6695L55.9259 69.7165L96.441 69.5033L96.3885 59.5257C95.6761 58.2193 92.977 54.7666 87.8797 51.407C81.508 47.2075 75.8366 61.1457 69.4728 58.458Z",
    fill: "#EFCC90"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4689,
    cy: 48.8128,
    r: 3.32648,
    transform: "rotate(-0.301531 62.4689 48.8128)",
    fill: "#EFCC90"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5918,
    y: 81.1367,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.2598,
    y: 81.1367,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9277,
    y: 81.1367,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 81.5957,
    y: 81.1367,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 90.2637,
    y: 81.1367,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5918,
    y: 96.7988,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 64.2598,
    y: 96.7988,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9277,
    y: 96.7988,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 81.5957,
    y: 96.7988,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 90.2637,
    y: 96.7988,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5918,
    y: 104.904,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 64.2598,
    y: 104.904,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9277,
    y: 104.904,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 81.5957,
    y: 104.904,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 90.2637,
    y: 104.904,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5918,
    y: 88.9629,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 64.2598,
    y: 88.9629,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9277,
    y: 88.9629,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 81.5957,
    y: 88.9629,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 90.2637,
    y: 88.9629,
    width: 5.87195,
    height: 5.87195,
    fill: "#EFCC90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCon2);
export default __webpack_public_path__ + "static/media/con-2.ae8b5bd8ed3d24dfd35fa13817d224e3.svg";
export { ForwardRef as ReactComponent };